import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [state, setState] = useState("checking"); // checking | paid | failed
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(data.status)) {
          setState("failed");
          return;
        }
      } catch (e) {
        // keep trying
      }
      if (tries >= 10) {
        setState("failed");
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F1EA] p-5" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-xl">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-navy" />
            <h1 className="mt-5 font-head text-xl font-bold text-navy">Verifica del pagamento…</h1>
            <p className="mt-2 text-sm text-slate-500">Attendi qualche istante.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
            <h1 className="mt-5 font-head text-2xl font-bold text-navy">Abbonamento rinnovato!</h1>
            <p className="mt-2 text-sm text-slate-500">Grazie. L'accesso è di nuovo attivo e i tuoi dati sono tutti al loro posto.</p>
            <a data-testid="go-to-app-btn" href="/" className="mt-6 inline-block rounded-lg bg-navy px-6 py-3 font-semibold text-white hover:bg-navy-hover">
              Entra nell'app
            </a>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="mx-auto h-14 w-14 text-red-500" />
            <h1 className="mt-5 font-head text-2xl font-bold text-navy">Pagamento non confermato</h1>
            <p className="mt-2 text-sm text-slate-500">Non siamo riusciti a confermare il pagamento. Riprova dall'app.</p>
            <a href="/" className="mt-6 inline-block rounded-lg bg-navy px-6 py-3 font-semibold text-white hover:bg-navy-hover">Torna all'app</a>
          </>
        )}
      </div>
    </div>
  );
}
